import { FC } from 'react';
import DOMPurify from 'dompurify';
import Tag from '@components/tag/Tag';
import theme from '../../../../../shared/assets/palette.json';
import { Container, Detail, ListTag, MainAction, Title } from './Main.style';
interface Props {
  title: string;
  description?: string;
  tag?: string[];
  like?: {
    isLiked: boolean;
    amount: number;
  };
}
const MainDetail: FC<Props> = ({
  title,
  description,
  tag,
  like
}: Props) => {
  return <Container>
            <Title>{title}</Title>
            <Detail dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(description)
    }} />
            <MainAction>
                <ListTag>
                    {tag?.map((tagName, index) => <Tag key={index} text={tagName} bgColor="transparent" borderColor={theme.grey[20]} />)}
                </ListTag>
            </MainAction>
        </Container>;
};
export default MainDetail;